/* Reformly V4 nav — mega-menu panels.

   Mirrors the export's own state machine:

     - hovering a top link with a panel opens that panel (openMenu(name))
     - moving between top links swaps panels with no close in between
     - leaving the whole nav closes after 120ms (`_closeTimer`), so crossing
       the gap between a link and its panel does not flicker it shut
     - the open link keeps a solid underline (`shopUnderline`)
     - the card turns opaque while a panel is open (`navBg`)

   Hover, not click, because that is what the design does — but every trigger
   is still focusable and Escape closes, so the panels are reachable without a
   pointer. Below 1080 the triggers are not rendered and this does nothing.
*/
(function () {
  var roots = document.querySelectorAll('[data-rfn]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var card = root.querySelector('.rfn__card');
    var triggers = root.querySelectorAll('[data-rfn-panel]');
    var panels = root.querySelectorAll('[data-rfn-panel-for]');
    if (!card || !triggers.length) return;

    var closeTimer = null;
    var openId = null;

    /* The panels only exist above 1080. Checked at call time rather than once
       at load: a desktop window dragged narrow must stop opening them, and a
       narrow one widened must start. */
    var canOpen = function () {
      return window.matchMedia('(min-width: 1080px)').matches;
    };

    function paint() {
      Array.prototype.forEach.call(panels, function (p) {
        var on = p.getAttribute('data-rfn-panel-for') === openId;
        p.hidden = !on;
      });
      Array.prototype.forEach.call(triggers, function (t) {
        var on = t.getAttribute('data-rfn-panel') === openId;
        t.classList.toggle('is-open', on);
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      card.classList.toggle('is-open', openId !== null);
    }

    function open(id) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (!canOpen() || openId === id) return;
      openId = id;
      paint();
    }

    function close(now) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openId === null) return;
      if (now) {
        openId = null;
        paint();
        return;
      }
      /* 120ms, the export's. Long enough to cross the gap between a link and
         the panel below it, short enough not to feel stuck open. */
      closeTimer = setTimeout(function () {
        openId = null;
        paint();
      }, 120);
    }

    Array.prototype.forEach.call(triggers, function (t) {
      var id = t.getAttribute('data-rfn-panel');
      t.addEventListener('mouseenter', function () { open(id); });
      t.addEventListener('focus', function () { open(id); });
      /* A trigger that is also a link must still navigate on click; opening on
         click as well would mean a tap both opened the panel and left the page. */
    });

    /* THE SUB-PANEL IS STATE, NOT HOVER.

       Hovering "Grip Socks" in the rail shows its links over the first tile.
       Keying that on `:hover` meant the panel vanished the moment the pointer
       left the row — and the links are in the other column, so they could
       never be reached. The export does not use hover for this: mouseenter on
       a parent row SETS `sockSub`, and only mouseenter on a different rail row
       or a tile clears it, so the panel survives the journey across the gap.

       Mirrored here as an attribute on the grid, which the per-menu rules in
       reformly-nav.liquid key off. Index, not id: the pairing with
       data-rfn-sublist is positional.

       `data-rfn-sublast` is the export's `lastSub`: which list the one card
       shows. Set on open and never cleared, so the card fades out holding
       the links it faded in with. Focus sets it too — keyboard users open
       the card through :focus-within in the CSS, not through mouseenter. */
    Array.prototype.forEach.call(root.querySelectorAll('.rfn__panel-grid'), function (grid) {
      var setSub = function (n) {
        if (n === null) { grid.removeAttribute('data-rfn-subopen'); return; }
        grid.setAttribute('data-rfn-subopen', n);
        grid.setAttribute('data-rfn-sublast', n);
      };

      Array.prototype.forEach.call(grid.querySelectorAll('[data-rfn-sub]'), function (row) {
        row.addEventListener('mouseenter', function () {
          setSub(row.getAttribute('data-rfn-sub'));
        });
        row.addEventListener('focusin', function () {
          grid.setAttribute('data-rfn-sublast', row.getAttribute('data-rfn-sub'));
        });
      });

      /* Everything else in the panel clears it: the rail rows with no children
         and the promo tiles. The sub-panel itself is deliberately NOT in this
         list — moving into it is the whole point. */
      Array.prototype.forEach.call(
        grid.querySelectorAll('.rfn__panel-link:not(.rfn__panel-link--parent), a.rfn__tile'),
        function (el) {
          el.addEventListener('mouseenter', function () { setSub(null); });
        }
      );

      /* And it goes with the mega panel. Without this the sub stays latched and
         is still showing the next time that panel opens. */
      var owner = grid.closest('[data-rfn-panel-for]');
      if (owner) owner.addEventListener('mouseleave', function () { setSub(null); });
    });

    /* Links WITHOUT a panel close it. The export binds `closeNow` to App and
       Sale for exactly this: sliding past them from Socks should dismiss the
       Socks panel rather than leave it hanging. */
    Array.prototype.forEach.call(root.querySelectorAll('.rfn__link'), function (l) {
      if (l.hasAttribute('data-rfn-panel')) return;
      l.addEventListener('mouseenter', function () { close(true); });
    });

    /* BOUND TO THE CARD, not the root — the root is the wrong shape.

       `.rfn` is full-bleed (measured 1440 wide at 1440) while the card and the
       panel hanging off it are 1300 centred, so there is a ~70px gutter down
       each side that belongs to the root but shows nothing. Leaving sideways
       into that gutter never fired `mouseleave`, and the panel stayed open with
       the pointer well clear of the menu — reported, then reproduced: exiting
       left at panel height left it open indefinitely.

       The card is the right boundary because it contains BOTH the link row and
       the panel (card 51-477 encloses panel 111-477), which is what the old
       comment here was worried about: a listener that fired while the pointer
       travelled from a link down into its own panel. It does not — that whole
       journey is inside the card. */
    /* DELIBERATELY NOT THE EXPORT'S BOUNDARY. V4 binds closeShop to the 1340px
       padded wrapper; here that is the full-bleed root, whose empty side
       gutters never fire mouseleave and left panels stuck open. The card is
       the right shape. Do not "correct" this back on a 1:1 pass. */
    card.addEventListener('mouseleave', function () { close(false); });
    card.addEventListener('mouseenter', function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close(true);
    });

    /* Focus moving out of the nav entirely closes it — otherwise tabbing from
       the last panel link into the page leaves the panel open behind you. */
    document.addEventListener('focusin', function (e) {
      if (openId !== null && !root.contains(e.target)) close(true);
    });

    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1080px)');
      var onChange = function () { close(true); };
      if (mq.addEventListener) { mq.addEventListener('change', onChange); }
      else if (mq.addListener) { mq.addListener(onChange); }
    }

    /* ---------- Market switch, without leaving the page ----------

       The theme's localization-form.js answers a click by calling
       form.submit() — a real navigation to /localization, which bounces back
       via the form's return_to. That works, but the buyer watches the page go
       away and come back, and any hiccup in the round trip leaves them parked
       on /localization looking at nothing.

       POST the same form with fetch instead and reload in place. Identical
       request, identical result server-side; no intermediate page.

       Bound in the CAPTURE phase with stopImmediatePropagation so it runs
       before localization-form.js's own bubble-phase handler, which would
       otherwise submit the form underneath us and navigate anyway. */
    var locForm = root.querySelector('.rfn__loc form');
    if (locForm) {
      var locInput = locForm.querySelector('input[name="country_code"]');
      Array.prototype.forEach.call(root.querySelectorAll('.rfn__loc-link'), function (link) {
        link.addEventListener('click', function (e) {
          var iso = link.getAttribute('data-value');
          if (!iso || !locInput) return;
          e.preventDefault();
          e.stopImmediatePropagation();

          /* Already on it — just close the card. */
          if (iso === locInput.value) {
            var btn = root.querySelector('.rfn__loc-btn');
            var panel = root.querySelector('.rfn__loc-list');
            if (panel) panel.setAttribute('hidden', '');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            return;
          }

          locInput.value = iso;
          link.setAttribute('aria-busy', 'true');

          fetch(locForm.getAttribute('action') || '/localization', {
            method: 'POST',
            body: new FormData(locForm),
            headers: { 'Accept': 'text/html' }
          })
            .then(function () { window.location.reload(); })
            /* If the request fails, fall back to the behaviour we replaced
               rather than leaving the buyer on a dead control. */
            .catch(function () { locForm.submit(); });
        }, true);
      });
    }

    /* ---------- Scrolled state (phones) ----------

       The mobile export flips at `scrollY > 88` — its own nav height — from a
       flush square bar to the inset floating pill. CSS owns the appearance;
       this only decides when.

       rAF-throttled and passive: a scroll listener that writes to the DOM on
       every event is the classic way to make a phone nav judder. The class is
       only written when it actually changes.

       Not gated on a media query here — the CSS already scopes every scrolled
       rule to max-width 899, so above that the class is inert. One less thing
       to keep in step. */
    /* TWO THRESHOLDS, NOT ONE — the bar used to flutter around the boundary.

       With a single `> 88` test, any scroll that hovers near 88 flips the
       class on and off repeatedly, restarting the 220ms transition each time.
       The bar visibly shimmers between flush and floating without the finger
       really moving.

       A phone makes this far likelier than a desktop, for two reasons that do
       not exist here in a headless browser:

         - momentum scrolling drifts back and forth across a point as it settles
         - collapsing the iOS address bar changes scrollY by ~60px on its own,
           with no gesture at all, which can cross 88 by itself

       So: detach at 88, which is the export's number and stays the moment the
       bar lifts, but do not re-attach until 56. The 32px band is wide enough
       that nothing short of a deliberate scroll back to the top crosses both,
       and because the bar only re-attaches near the top, the asymmetry is
       invisible in use. */
    var ENTER_AT = 88;
    var LEAVE_AT = 56;

    var scrolled = false;
    var ticking = false;
    function syncScrolled() {
      var y = window.scrollY || window.pageYOffset || 0;
      var next = scrolled ? y > LEAVE_AT : y > ENTER_AT;
      if (next !== scrolled) {
        scrolled = next;
        root.classList.toggle('is-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncScrolled(); });
    }, { passive: true });
    /* Run once: a reload part-way down the page must start in the right state. */
    syncScrolled();

    /* ---------- Mobile drawer ----------

       A VIEW SWAP, not an accordion: tapping "Grip Socks" replaces the whole
       list with its own, and a back row returns. That is what the export does
       (`mainMenuOpen` / `sockMenuOpen` are mutually exclusive), and it is why
       every view is rendered up front and only `hidden` moves.
    */
    var drawer = document.getElementById(
      (root.querySelector('[data-rfn-burger]') || {}).getAttribute
        ? root.querySelector('[data-rfn-burger]').getAttribute('aria-controls')
        : ''
    );
    var burger = root.querySelector('[data-rfn-burger]');
    if (!drawer || !burger) return;

    var views = drawer.querySelectorAll('[data-rfn-view]');
    var lastFocus = null;

    var panelEl = drawer.querySelector('.rfn-drawer__panel');
    /* The views live in their own scroll box so the head sits outside it (see
       the note in the markup). Everything that reads or writes a scroll
       position, and the box the sliding view is positioned against, is THIS
       element; the sheet itself only still owns the height animation, because
       the bottom edge that travels is the sheet's. Falls back to the panel so
       a cached template without the wrapper still works. */
    var scrollEl = drawer.querySelector('.rfn-drawer__scroll') || panelEl;

    /* HAND THE CLOSED STATE OVER FROM `hidden` TO `inert`, once, at init.

       The markup ships with `hidden` so the sheet is not visible before this
       script runs and stays hidden if it never does. From here on the closed
       state is `inert`: it keeps the subtree out of the a11y tree and
       unfocusable, but unlike `hidden` (display) and `visibility` it changes
       nothing inherited, so a toggle no longer invalidates the style of the
       whole drawer. The sheet is invisible because the scrim and panel sit at
       opacity 0 until `.is-open`.

       Paying it here means the one-time layout and style pass lands during
       load rather than on the user's first tap. */
    if (drawer.hidden) {
      drawer.hidden = false;
      drawer.setAttribute('inert', '');
    }

    var EZ = 'cubic-bezier(0.32,0.72,0,1)';

    /* THE SHEET IS ONE GESTURE, so it gets ONE curve and ONE duration — the
       same discipline that makes the bar's fixed-to-floating transition read
       the way it does (see the note on .rfn__wrap's transition: every property
       in that group shares 300ms and cubic-bezier(0.4, 0, 0.2, 1) "because
       they describe one gesture and must not drift apart").

       The drawer had six timings and five curves pulling against each other:
       the reveal on 420ms EZ, the content on 380ms after a 40ms hold, the X on
       400, its paths on 380 MZ, the middle bar on ease-out, the icons on 260
       staggered 30ms apart, the bag on 160 — and a close that ran a different
       curve at 1.8x. Each finished at its own moment, so the sheet arrived in
       pieces rather than as one movement.

       Symmetric, too: the close plays the same curve at the same rate instead
       of a faster one, which is what makes the bar's transition read as the
       same object moving back. */
    var SHEET_MS = 300;
    var SHEET_EZ = 'cubic-bezier(0.4, 0, 0.2, 1)';
    /* THE CORNER IS SHARED, and the sheet performs the handover.

       The bar's rightmost icon is the bag, the head's is the account glyph,
       and they do not line up -- 349.8 against 328.3 at 390px wide, further
       apart on a real phone where no scrollbar narrows the bar.

       Nothing here writes an opacity for either of them, because the sheet
       already is one: the glyph is INSIDE the sheet and the bag BEHIND it, so
       what you see of them is `glyph x sheet` and `bag x (1 - sheet)` -- exact
       inverses, crossing at a half each. Fading them by hand on top of that
       made the glyph vanish ~35ms early on its own curve while doing nothing
       at all for the bag, whose opacity cannot show through an opaque sheet
       whatever value it is given.

       So the sheet owns the fade and SCALE owns the motion. A rotation was
       tried here and removed: a face's visible area falls off as its cosine,
       so most of the arc is spent near edge-on and squashed, and the glyph
       read as sticking halfway through rather than arriving.

       CART_IN is where the bag starts growing on the close -- early enough
       that it is most of the way up as the sheet clears, since its own value
       cannot show before then anyway. */
    var CART_IN = 140;
    var CART_MS = SHEET_MS;
    /* Every path that can leave the bar's bag mid-animation has to clear it,
       or the shop is left with a shrunken cart icon. Called from headIntro,
       from headOutro before it hands the bag its own entrance, and from the
       instant teardown in closeDrawer. */
    function clearCartAnim() {
      var c = root.querySelector('#cart-icon-bubble');
      if (!c || !c.getAnimations) return null;
      c.getAnimations().forEach(function (a) {
        if (!(window.CSSAnimation && a instanceof window.CSSAnimation)) a.cancel();
      });
      return c;
    }
    function reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function showView(name) {
      Array.prototype.forEach.call(views, function (v) {
        v.hidden = v.getAttribute('data-rfn-view') !== name;
      });
      /* Back to the top on every swap — the sheet scrolls, and arriving
         part-way down a sub-list reads as a broken transition.

         The element is looked up ONCE above rather than per call: querySelector
         inside a handler that also writes scrollTop is a read-then-write on the
         same frame, which is the shape that forces a synchronous layout. */
      if (scrollEl) scrollEl.scrollTop = 0;
    }

    /* SUB-VIEWS SLIDE — V4's horizontal slide between the main menu and a
       category's list ("Pilates Equipment", "Grip Socks").

       The outgoing view is lifted out of flow at its current spot and pushed
       off one side while the incoming one comes in from the other, both
       340ms on the export's curve; forward goes left, back goes right. The
       sheet's height eases to the new content over the same 340ms, so the
       bottom edge travels with the slide instead of jumping.

       Only once the sheet has finished arriving (`.is-ready`). Before that,
       and under reduced motion, it is the plain swap. */
    function slideTo(name) {
      var cur = null, next = null;
      Array.prototype.forEach.call(views, function (v) {
        if (!v.hidden) cur = v;
        if (v.getAttribute('data-rfn-view') === name) next = v;
      });
      if (!cur || !next || cur === next || !panelEl || !panelEl.animate ||
          reduced() || !drawer.classList.contains('is-ready')) {
        showView(name);
        return;
      }

      var dir = name === 'main' ? -1 : 1;
      var w = scrollEl.clientWidth;
      var h0 = panelEl.offsetHeight;
      var cs = getComputedStyle(scrollEl);
      /* THE OUTGOING VIEW LEAVES FROM WHERE IT IS ON SCREEN, not from where it
         would be at scrollTop 0.

         showView resets the scroll on every swap, and the slide did too: the
         sub-list jumped back to its top and only then slid away. Going in
         that never showed, because a sub-list is entered at the top anyway.
         Coming BACK it always did - the list has been scrolled by then, which
         is the whole reason the user is reaching for Back - so the animation
         began with a jump the length of however far they had read.

         `offsetTop` is layout-relative, so subtracting the scroll offset puts
         the absolutely positioned copy exactly where the eye last had it, and
         the slide starts from a standstill. */
      var top = cur.offsetTop - scrollEl.scrollTop;

      scrollEl.scrollTop = 0;
      cur.style.cssText = 'position:absolute;top:' + top + 'px;left:' + cs.paddingLeft +
        ';right:' + cs.paddingRight + ';pointer-events:none;';
      next.hidden = false;
      var h1 = panelEl.offsetHeight;

      var out = cur.animate(
        [{ transform: 'translate3d(0,0,0)' }, { transform: 'translate3d(' + (-dir * w) + 'px,0,0)' }],
        { duration: SHEET_MS, easing: SHEET_EZ, fill: 'forwards' }
      );
      out.onfinish = function () {
        cur.hidden = true;
        cur.style.cssText = '';
        out.cancel();
      };
      next.animate(
        [{ transform: 'translate3d(' + (dir * w) + 'px,0,0)' }, { transform: 'translate3d(0,0,0)' }],
        { duration: SHEET_MS, easing: SHEET_EZ }
      );
      if (Math.abs(h1 - h0) >= 1) {
        panelEl.animate([{ height: h0 + 'px' }, { height: h1 + 'px' }], { duration: SHEET_MS, easing: SHEET_EZ });
      }
    }

    /* THE HEAD'S OPEN CHOREOGRAPHY — V4's, rebuilt against our markup.

       The burger becomes the close X: the X starts drawn as three bars at the
       burger's position, slides into the head (400ms) while its outer bars
       close in and rotate to ±45° and the middle one shrinks away (380ms).
       The wordmark slides from the bar's wordmark to its place in the head,
       a copy of the bar's bag fades out where the bag was, and the other head
       icons scale in, 30ms apart.

       All Web Animations, so closeDrawer can play the same set backwards. */
    var headEl = drawer.querySelector('.rfn-drawer__head');

    /* NO BAG IS ANIMATED HERE, and that is deliberate — it used to be.

       A clone of the bar's bag was placed in the head at the bar bag's own
       coordinates and cross-faded, on the belief that the bag would otherwise
       show beside the sheet: `#cart-icon-bubble` is a 44px tap box reaching to
       369 at 390px wide, 10px past the sheet's right edge of 359. But the box
       paints nothing. The GLYPH inside it measures 342.5..357 and is covered
       by the sheet with 2px to spare, so there was never a sliver to hide.

       The clone only created work: it had to be positioned (its width differs
       from the original's, which is flex-shrunk in the bar), it was clipped by
       the sheet's own `overflow: hidden`, and it needed sweeping on open, on
       close and in the instant teardown. Worse, it put a SECOND bag in a
       corner that already swaps icons -- the bar's bag at x349.8 against the
       head's account glyph at x328.3 -- so a close read as a cart sitting
       21.5px inward and then jumping out. Fading, delaying and travelling the
       clone were all tried; none of them helped, because the displacement was
       never the clone's.

       What is left is what is true: the sheet covers the bar, and uncovers it
       again. The bag is occluded, not animated. */
    function headIntro() {
      if (!headEl || !headEl.animate || reduced()) return;
      headEl.getAnimations({ subtree: true }).forEach(function (a) {
        if (!(window.CSSAnimation && a instanceof window.CSSAnimation)) a.cancel();
      });
      /* The bag lives OUTSIDE the head, so the sweep above does not reach its
         flip from the last close. */
      clearCartAnim();
      var xs = headEl.querySelector('[data-rfn-x]');
      var dlogo = headEl.querySelector('.rfn-drawer__logo');
      var blogo = root.querySelector('.rfn__logo');
      var MZ = 'cubic-bezier(0.65,0,0.35,1)';

      if (xs) {
        var ra = burger.getBoundingClientRect(), rb = xs.getBoundingClientRect();
        var dx = (ra.left + ra.width / 2) - (rb.left + rb.width / 2);
        var dy = (ra.top + ra.height / 2) - (rb.top + rb.height / 2);
        xs.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'translate(0px,0px)' }],
          { duration: SHEET_MS, easing: SHEET_EZ, fill: 'both' });
        var ps = xs.querySelectorAll('path');
        var bar = function (el, y, deg) {
          el.animate([
            { transform: 'translateY(' + y + 'px) rotate(0deg) scaleX(1)', easing: SHEET_EZ },
            { offset: 0.42, transform: 'translateY(0px) rotate(0deg) scaleX(1)', easing: SHEET_EZ },
            { transform: 'translateY(0px) rotate(' + deg + 'deg) scaleX(0.943)' }
          ], { duration: SHEET_MS, easing: SHEET_EZ, fill: 'both' });
        };
        if (ps.length === 3) {
          bar(ps[0], -6, 45);
          bar(ps[2], 6, -45);
          ps[1].animate([
            { opacity: 1, transform: 'scaleX(1)' },
            { offset: 0.38, opacity: 0, transform: 'scaleX(0.2)' },
            { opacity: 0, transform: 'scaleX(0.2)' }
          ], { duration: SHEET_MS, easing: SHEET_EZ, fill: 'both' });
        }
      }

      if (dlogo && blogo) {
        var la = blogo.getBoundingClientRect(), lb = dlogo.getBoundingClientRect();
        if (Math.abs(la.top - lb.top) > 0.5 || Math.abs(la.left - lb.left) > 0.5) {
          /* End on the CSS transform as computed, whatever this width's
             nudge is (+1px on the phone, +3px from 900). */
          var rest = getComputedStyle(dlogo).transform;
          rest = rest === 'none' ? '' : rest;
          dlogo.animate([
            { transform: 'translate(' + (la.left - lb.left) + 'px,' + (la.top - lb.top) + 'px) ' + rest },
            { transform: rest || 'none' }
          ], { duration: SHEET_MS, easing: SHEET_EZ, fill: 'both' });
        }
      }

      /* THE CORNER IS SHARED by the bar's bag and the head's account glyph,
         which do not line up and must never look like one icon moving between
         the two positions. The sheet performs the handover -- see CART_IN,
         where the reasoning and the measurements live. */
      /* The glyph arrives with the rest of the head's icons, no special case:
         its opacity is multiplied by the sheet's as the sheet covers the bag,
         which is the handover. */
      var k = 0;
      Array.prototype.forEach.call(headEl.children, function (el) {
        if ((xs && el.contains(xs)) || el === dlogo ||
            el.classList.contains('rfn-drawer__spacer')) return;
        el.animate([{ opacity: 0, transform: 'scale(0.82)' }, { opacity: 1, transform: 'scale(1)' }],
          { duration: SHEET_MS, easing: SHEET_EZ, fill: 'both' });
        k++;
      });
    }

    /* Close: the head's own animations run backwards at 1.8x. */
    function headOutro() {
      if (!headEl || !headEl.getAnimations || reduced()) return;
      var acctEl = headEl.querySelector('.rfn-drawer__acct');
      headEl.getAnimations({ subtree: true }).forEach(function (a) {
        if (window.CSSAnimation && a instanceof window.CSSAnimation) return;
        /* The glyph does not reverse -- it gets its own exit, below. */
        if (acctEl && a.effect && a.effect.target === acctEl) { a.cancel(); return; }
        try { a.updatePlaybackRate(-1); a.play(); } catch (e) {}
      });
      if (acctEl) {
        /* Scale only, so the glyph has an exit of its own while its opacity
           stays the sheet's business. Faded by hand it was gone ~35ms before
           the bag came through and the corner blinked; held at full it reads
           as exactly the sheet's opacity, against the bag's inverse. */
        acctEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(0.82)' }],
          { duration: SHEET_MS, easing: SHEET_EZ, fill: 'both' });
      }

      /* And the bag grows in as the sheet clears, so the corner is handed
         over rather than uncovered. `backwards`, not `both`: the fill holds it
         at its start scale through the delay, while the sheet still covers it,
         then lets it fall back to the theme's own styles rather than pinning a
         transform on one of the theme's elements. Nothing here touches cart
         behaviour -- it is a scale animation on the nav's bag. */
      var barCart = clearCartAnim();
      if (barCart && barCart.animate) {
        barCart.animate([{ transform: 'scale(0.82)' }, { transform: 'scale(1)' }],
          { duration: CART_MS, delay: CART_IN, easing: SHEET_EZ, fill: 'backwards' });
      }
    }

    /* The clip the sheet grows out of. TOP IS PINNED at -40px in both frames,
       as in the export: the reveal only travels DOWN (and the sides out), so
       the sheet's top edge never moves. The start band is the sheet's top
       56px — its head row, the height of the closed bar — exactly V4's
       `inset(-40px 0 calc(100% - 56px) 0)`, radius 9 as in the export. */
    var fullClip = 'inset(-40px -40px -60px -40px round 9px)';
    /* The band is the head row's own height — 56 on the phone, 46 from 900
       where the head mirrors the compact bar. Read, not assumed. */
    function dropClip() {
      var h = headEl ? headEl.offsetHeight : 56;
      return 'inset(-40px 0px calc(100% - ' + h + 'px) 0px round 9px)';
    }

    /* THE REVEAL RUNS HERE, not from the CSS keyframes.

       Same values as the CSS keyframes, all literals. It moved here when the
       keyframes still read a measured strip through var(), which WebKit has a
       history of not resolving inside @keyframes; JS stays the primary path
       so there is one place that owns the reveal. `.rfn-js-reveal` switches the CSS
       keyframes off so the two can never run at once; they stay as the
       fallback where Element.animate is missing. Same curves and timings. */
    var revealAnim = null;
    var revealBand = -1;
    var jsReveal = !!(panelEl && panelEl.animate);
    if (jsReveal) drawer.classList.add('rfn-js-reveal');

    /* ONE animation, played forward to open and REVERSED to close.

       It used to be two: each call cancelled the running one and started a
       fresh keyframe effect. Cancelling discards the current position, so a
       close that interrupted an open restarted from fully-open - the sheet
       jumped open and then animated shut. That snap is what made the drawer
       feel unlike a native sheet, and it is worst exactly when people are
       quickest with it.

       Reversing keeps `currentTime`, so an interrupted open closes from
       wherever it actually got to, and a reopen mid-close catches the sheet
       on the way down. Half a gesture no longer costs a full 420ms.

       OPEN AND CLOSE KEEP THEIR OWN SPEEDS. One effect has one duration, so
       the close runs the same 420ms of keyframes faster via playbackRate:
       420 / 320 = 1.3125, which lands on the 320ms the close had before and
       keeps closeDrawer's 360ms teardown timer correct. reverse() negates
       whatever rate is set, so the rate is assigned before the call.

       The easing is now EZ in both directions. The close had material's
       0.4,0,0.2,1 against the open's iOS-style curve; one curve played
       backwards is what makes a sheet feel like one object. */
    function revealEffect() {
      var band = headEl ? headEl.offsetHeight : 56;
      if (revealAnim && band === revealBand) return revealAnim;
      // Head height changes at the 900 breakpoint, so the clip is rebuilt
      // rather than cached for the life of the page.
      if (revealAnim) revealAnim.cancel();
      revealBand = band;
      revealAnim = panelEl.animate([
        { clipPath: dropClip(), opacity: 0 },
        { offset: 0.2, opacity: 1 },
        { clipPath: fullClip, opacity: 1 }
      ], { duration: SHEET_MS, easing: SHEET_EZ, fill: 'both' });
      revealAnim.pause();
      return revealAnim;
    }

    function reveal(opening) {
      if (!jsReveal) return;
      if (reduced()) {
        if (revealAnim) { revealAnim.cancel(); revealAnim = null; revealBand = -1; }
        return;
      }
      var a = revealEffect();
      a.playbackRate = 1;
      if (opening) a.play(); else a.reverse();
    }

    var readyTimer = null;

    /* OPEN/CLOSE IS ANIMATED, which is why `hidden` is not the only thing that
       moves any more.

       `hidden` resolves to `display: none`, and display is not animatable — the
       sheet appeared and vanished in one frame while the export slides it in
       from the left behind a fading scrim. So the attribute still controls
       whether the drawer is in the layout (and still hides it from assistive
       tech when shut), and a separate `is-open` class drives the transition.

       OPENING needs two frames, not one. Setting `hidden = false` and adding
       the class in the same tick gives the browser nothing to interpolate
       from: it computes the final state once and paints it. The nested rAF
       lets the closed state render first, so the transition has a start.

       CLOSING waits for the transition to finish before re-hiding, with a
       timer as the backstop — `transitionend` never fires when the element is
       already in its end state, under prefers-reduced-motion, or if the panel
       is display:none'd by something else mid-flight, and without the fallback
       the drawer would stay in the DOM holding the page scroll lock. */
    var closeTimer = null;
    /* Separate from closeTimer: the page lock is applied after the open
       animation and released after the close one, so both are outside the
       frames that have to stay clean. See openDrawer. */
    var lockTimer = null;

    function openDrawer() {
      lastFocus = document.activeElement;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

      /* EVERYTHING THAT CAN FORCE LAYOUT IS DEFERRED PAST THIS FRAME.
         The tap handler now only flips attributes and a class — see the note
         after this function for what was in here and what it cost. */
      drawer.removeAttribute('inert');
      drawer.classList.remove('is-closing', 'is-ready');
      burger.setAttribute('aria-expanded', 'true');
      showView('main');

      /* ONE frame, not two. The two-rAF dance existed because `hidden` meant
         `display: none` and the browser had nothing to interpolate from until
         the closed state had painted. The closed state is now
         `visibility: hidden` with layout already computed, so a single frame is
         enough for the transition to have a start value. */
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        reveal(true);
        headIntro();
      });

      /* 450ms, V4's `data-navready`: after this a view swap slides rather
         than replaying the arrival blur. */
      if (readyTimer) clearTimeout(readyTimer);
      readyTimer = setTimeout(function () {
        drawer.classList.add('is-ready');
        readyTimer = null;
      }, 450);

      /* THE PAGE LOCK IS DEFERRED PAST THE ANIMATION, and it is the single
         biggest thing that was making this feel heavy.

         `overflow: hidden` on <html> changes the document's scroll container,
         so the browser relayouts the WHOLE PAGE — measured on the home page at
         4x throttle: 24.2ms to apply, 22.5ms to restore. Every drawer
         mutation put together is under 4ms, so this one line was the dropped
         frame on open and on close.

         Applying it after the sheet has finished arriving moves that relayout
         into dead time. The page cannot be scrolled in the meantime anyway:
         the scrim covers it with `touch-action: none`, and the panel carries
         `overscroll-behavior: contain`.

         320ms = just past the 300ms transform. Cancelled by closeDrawer if the
         sheet is dismissed before it fires, so a quick open/close never pays
         the cost at all. */
      if (lockTimer) clearTimeout(lockTimer);
      lockTimer = setTimeout(function () {
        document.documentElement.style.overflow = 'hidden';
        lockTimer = null;
      }, 320);

      /* focus() AFTER the frame, and with preventScroll.

         Both halves matter. Calling it synchronously forced a style/layout
         flush inside the handler, and focus() on an element in a freshly shown
         scroll container also makes the browser scroll it into view — a second
         layout read, and on a phone it can jump the panel. `preventScroll`
         removes the scrolling; the rAF moves the remaining cost out of the
         frame the user is waiting on. */
      requestAnimationFrame(function () {
        var first = drawer.querySelector('[data-rfn-drawer-close]');
        if (first) first.focus({ preventScroll: true });
      });
    }

    /* `instant` — NO ANIMATION, used by the back/bfcache restore below.

       Playing the close on a restore means the reader lands on the page they
       navigated back to and watches a menu they are not looking at fold
       itself away, bag fade and all. There is nothing to animate FROM: the
       sheet was never on screen in this paint. Everything the timed close
       does at its end is done here in one frame instead. */
    function closeDrawer(instant) {
      if (readyTimer) { clearTimeout(readyTimer); readyTimer = null; }
      if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }

      if (instant) {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        drawer.classList.remove('is-open', 'is-ready', 'is-closing');
        burger.setAttribute('aria-expanded', 'false');
        if (revealAnim) { revealAnim.cancel(); revealAnim = null; }
        clearCartAnim();
        if (headEl && headEl.getAnimations) {
          headEl.getAnimations({ subtree: true }).forEach(function (a) {
            if (!(window.CSSAnimation && a instanceof window.CSSAnimation)) a.cancel();
          });
        }
        drawer.setAttribute('inert', '');
        document.documentElement.style.overflow = '';
        return;
      }

      drawer.classList.add('is-closing');
      drawer.classList.remove('is-open', 'is-ready');
      reveal(false);
      headOutro();
      burger.setAttribute('aria-expanded', 'false');

      /* Deferred and preventScroll for the same reasons as the open path:
         returning focus to the burger synchronously flushed layout in the frame
         the close animation starts in, which is the frame that has to be clean
         for the sheet to move smoothly. */
      requestAnimationFrame(function () {
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      });

      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        /* `inert`, not `hidden`: re-hiding with display would put the layout
           cost back on the NEXT open. The sheet is already invisible by then —
           the class came off 360ms ago — so this only re-arms the a11y and
           focus guard. 360ms: the sheet's close is a 20ms hold plus 320ms. */
        drawer.setAttribute('inert', '');
        drawer.classList.remove('is-closing');
        if (revealAnim) { revealAnim.cancel(); revealAnim = null; }
        /* Releasing the lock relayouts the page (22.5ms), so it waits for the
           close animation to be over for the same reason applying it does. */
        document.documentElement.style.overflow = '';
        closeTimer = null;
      }, 360);
    }

    /* Keyed on the CLASS, not on `hidden`. During the closing transition the
       drawer is still un-hidden for ~340ms, so testing `hidden` here made a
       burger tap in that window call closeDrawer again — the sheet stayed
       shut and the next tap did nothing. */
    burger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
    });

    Array.prototype.forEach.call(drawer.querySelectorAll('[data-rfn-drawer-close]'), function (el) {
      /* Wrapped, not passed directly: the listener's MouseEvent would land in
         closeDrawer's `instant` arg and tear the sheet down in one frame with
         no animation. */
      el.addEventListener('click', function () { closeDrawer(); });
    });

    Array.prototype.forEach.call(drawer.querySelectorAll('[data-rfn-view-open]'), function (el) {
      el.addEventListener('click', function () {
        slideTo(el.getAttribute('data-rfn-view-open'));
      });
    });

    document.addEventListener('keydown', function (e) {
      /* Keyed on the class, like the burger toggle. `!drawer.hidden` is now
         always true — init cleared the attribute for good — so this would have
         fired closeDrawer on every Escape anywhere on the page. */
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* BACK FROM A LINK TAPPED INSIDE THE DRAWER leaves it open.

       The nav is a section, re-rendered server-side on every page, so there
       is no shared state carrying it across — the drawer is open because
       Safari restored the PREVIOUS page from bfcache. A bfcache restore
       hands back the live DOM exactly as it was abandoned: `.is-open` still
       set, `inert` still cleared, the scroll lock still applied. No script
       re-runs, because the document was never torn down, so nothing closes
       it.

       Closing it here puts the page back in the state a reader expects:
       they tapped a link, came back, and should be looking at the page they
       came back to rather than the menu they left open on top of it.

       Not gated on `event.persisted` alone. Shopify sends no-store on most
       pages, so a back is often a history RELOAD rather than a true bfcache
       restore; `back_forward` covers that case. Harmless either way — on a
       fresh load the drawer is already closed and closeDrawer() is a no-op. */
    window.addEventListener('pageshow', function (e) {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!e.persisted && !(nav && nav.type === 'back_forward')) return;
      if (drawer.classList.contains('is-open')) closeDrawer(true);
    });

    /* Crossing up to the desktop layout with the sheet open would leave the
       page scroll-locked behind a drawer CSS has just hidden. */
    if (window.matchMedia) {
      var dmq = window.matchMedia('(min-width: 1080px)');
      var onWide = function () {
        if (drawer.classList.contains('is-open')) closeDrawer();
      };
      if (dmq.addEventListener) { dmq.addEventListener('change', onWide); }
      else if (dmq.addListener) { dmq.addListener(onWide); }
    }
  });
})();
